import React from "react";
import FigmaIcon from "./FigmaIcon";
export default function TeamMemberAddIcon(props) { return <FigmaIcon name="popup-owner" {...props} />; }
